module.exports = new __parcel__URL__("chevron-up.aa6afa50.svg").toString();